export const locale = {
    lang: 'ds',
    data: {
        'BUTTONS': {
            'GO': 'OK',
            'CANCEL': 'Fortryd'
        }
    }
}